import { render } from "./StaffDatatableTDProfession.vue?vue&type=template&id=0a316624"
import script from "./StaffDatatableTDProfession.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTDProfession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__